import React from "react";
import './template_service_pages.css';
import Navbar from "../../components/navbar/navbar";
import job_interview from '../../assets/images/job_interview.png';
import { Link } from "react-router-dom";
import icon1 from './service_icons/icon1.png'
import icon2 from './service_icons/icon2.png'
import icon3 from './service_icons/icon3.png'
import icon4 from './service_icons/icon4.png'
// import servicebanner from './service_banner.png'
function HomeBuyers(){
    return(
        <>
        <Navbar/>
        <div data-aos="fade-in">
        <div className="services_banner">
            <div>
                <h2>Home Buying Services</h2>
                <p>
                    Navigating the property market can be overwhelming, but with Buyers Galaxy, it doesn’t have to
                    be. Our Home Buying Services are designed to make your journey to homeownership seamless,
                    informed, and stress-free. Whether you're a first-time buyer, upgrading to your dream home,
                    or searching for the perfect investment, we provide end-to-end support tailored to your
                    unique goals.
                </p>
                <Link to="/contact" className="btn">Contact Us</Link>
            </div>
        </div>
        <div className="service_offer">
            <h2 className="offer">What We Offer</h2>
            <div className="offer_blocks">
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon1} alt="" />
                    </div>
                    <div>
                        <h5>Negotiation Advantage</h5>
                        <p>Our professional negotiation skills ensure you secure your dream home under the best possible terms and conditions.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon2} alt="" />
                    </div>
                    <div>
                        <h5>Market Expertise</h5>
                        <p>With our deep knowledge of Melbourne’s property market, we help you identify opportunities, assess market value,
                        and avoid overpaying</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon3} alt="" />
                    </div>
                    <div>
                        <h5>Personalized Property Search</h5>
                        <p>We take the time to understand your needs, preferences, and financial goals to find properties that perfectly align with your vision.</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
                <div className="service_box">
                    <div className="service_icon">
                        <img src={icon4} alt="" />
                    </div>
                    <div>
                        <h5>Comprehensive Support</h5>
                        <p>From initial consultation to settlement, we handle every detail, giving you peace of mind throughout the process</p>
                    </div>
                    <Link to="/contact">Get Started</Link>
                </div>
            </div>
        </div>
        <div className="services_info_bottom">
            <p>Discover Melbourne's no-go suburbs for Investment</p>
            <Link to='/download'>Download Now</Link>
        </div>
        <div className="services_info">
            <div className="service_img_detail">
                <h2>Why Choose Us?</h2>
                <p>At Buyers Galaxy, we don’t just help you buy a house—we help you find a place to call home or a strategic addition to your property portfolio. Our goal is to simplify the process, save you time, and maximize the value of your investment.</p>
                {/* <Link to="/contact" className="con-btn">Get a House Now</Link> */}
            </div>
            <img src={job_interview} alt="" />
        </div>
        <div className="services_details"></div>
        </div>
        </>
    );

}
export default HomeBuyers;